import { useRef } from "react";
import {
  Grid,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
  FormControl,
  TextFieldMedidas,
} from "../../../../../components";
import constantes from "../../resources/constantes";

const NfSaidaTransporte = ({
  id,
  nfSaida,
  setNfSaida,
  nfSaidaEntity,
  transportadoraList,
  transportadoraSelecionada,
  setTransportadoraSelecionada,
  inputErros,
  handleInputChange,
  onChangeAutocomplete,
  onSearchChangePessoas,
  buscarDadosTransportadora,
}) => {
  const inputRef = useRef();

  const onChangeAutocompleteTransportadora = (newValue) => {
    onChangeAutocomplete("transportadoraId", newValue);
    setTransportadoraSelecionada(newValue);
    buscarDadosTransportadora(newValue?.id);
  };

  const handleInputChangeMedidas = (e) => {
    nfSaidaEntity.setMedidas(e.target.name, e.target.value);
    setNfSaida({ ...nfSaidaEntity });
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={5}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              id="transportadoraId"
              name="transportadoraId"
              options={transportadoraList}
              autoHighlight
              disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              getOptionLabel={(option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.nomeRazaoSocial}`;
                return option ? descricaoProduto : "";
              }}
              filterSelectedOptions
              onChange={(_, newValue) =>
                onChangeAutocompleteTransportadora(newValue)
              }
              value={transportadoraSelecionada}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant={"outlined"}
                  label="Transportadora"
                  onKeyDown={(e) => onSearchChangePessoas(e, inputRef, 3)}
                  inputRef={inputRef}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={5}>
          <Select
            id="modalidadeFrete"
            name="modalidadeFrete"
            margin="normal"
            label="Modalidade Frete"
            error={inputErros.get("modalidadeFrete")}
            variant={"outlined"}
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            value={nfSaida?.modalidadeFrete ?? "mfSemFrete"}
            onChange={(event) => handleInputChange(event)}
            required
          >
            {constantes.modalidadeFrete.map((modalidade) => (
              <MenuItem key={modalidade.value} value={modalidade.value}>
                {modalidade.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={2}>
          <Select
            label="Frete Compõe Total da Nota?"
            id="freteCompoeNota"
            name="freteCompoeNota"
            margin="normal"
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            variant={"outlined"}
            value={nfSaida?.freteCompoeNota ?? false}
            required
            fullWidth
            onChange={(event) => handleInputChange(event)}
          >
            <MenuItem value={true}>Sim</MenuItem>
            <MenuItem value={false}>Não</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="qtdVolumes"
            name="qtdVolumes"
            label="QTD Volumes"
            type="number"
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            variant={"outlined"}
            value={nfSaida?.qtdVolumes}
            onChange={(event) => handleInputChange(event)}
          />
        </Grid>
        <Grid item xs={2}>
          <TextFieldMedidas
            id="pesoBruto"
            name="pesoBruto"
            label="Peso Bruto"
            margin="none"
            unit="g"
            shrink
            decimalScale={3}
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            value={nfSaida?.pesoBruto}
            onBlur={handleInputChangeMedidas}
          />
        </Grid>
        <Grid item xs={2}>
          <TextFieldMedidas
            id="pesoLiquido"
            name="pesoLiquido"
            label="Peso Líquido"
            margin="none"
            unit="g"
            shrink
            decimalScale={3}
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            value={nfSaida?.pesoLiquido}
            onBlur={handleInputChangeMedidas}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="produtoMarca"
            name="produtoMarca"
            label="Marca"
            margin="none"
            type="text"
            variant={"outlined"}
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            value={nfSaida?.produtoMarca}
            onChange={(event) => handleInputChange(event)}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="produtoNumero"
            name="produtoNumero"
            label="Número"
            margin="none"
            type="text"
            variant={"outlined"}
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            value={nfSaida?.produtoNumero}
            onChange={(event) => handleInputChange(event)}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="especieVolume"
            name="especieVolume"
            label="Volume"
            margin="none"
            type="text"
            variant={"outlined"}
            disabled={id || !nfSaida?.operacaoFiscalId ? true : false}
            value={nfSaida?.especieVolume}
            onChange={(event) => handleInputChange(event)}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default NfSaidaTransporte;
